import { useInfoPagesControllerDeleteInfoPageMutation } from '@api/admin/adminGeneratedApi';
import { useNotifications } from '@area/notifications/hooks/useNotifications';
import { useState, useEffect } from 'react';

export const useDeleteInfoPage = (cb: () => void) => {
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);
  const [deletingRowId, setDeletingRowId] = useState<string | null>(null);
  const [loadingRowId, setloadingRowId] = useState<string>();
  const { handlePushItem } = useNotifications();
  const [deleteInfoPage, { isSuccess, status }] = useInfoPagesControllerDeleteInfoPageMutation();

  const openDeleteConfirmationModal = (id: string) => {
    setDeletingRowId(id);
    setDeleteConfirmationModalOpen(true);
  };

  const closeDeleteConfirmationModal = () => {
    setDeletingRowId(null);
    setDeleteConfirmationModalOpen(false);
  };

  const confirmDelete = () => {
    deleteInfoPage({ id: deletingRowId! });
    setloadingRowId(deletingRowId!);
    closeDeleteConfirmationModal();
  };

  useEffect(() => {
    if (isSuccess && status === 'fulfilled') {
      handlePushItem({ severity: 'success', text: 'Информационная страница успешно удалена' });
      cb();
    }
  }, [isSuccess, status]);

  return {
    deleteConfirmationModalOpen,
    openDeleteConfirmationModal,
    closeDeleteConfirmationModal,
    confirmDelete,
    loadingRowId,
  };
};
